import { Link } from 'react-router-dom';

function email(original) {
  return (
    <Link to={`/users/edit/${original?.id}`}>{original?.email || ''}</Link>
  );
}

function enabled(original) {
  return original?.enabled ? 'Enabled' : 'Disabled';
}

export { email, enabled };
